// ABOUTME: The feed only for a talent with PRO_JOB_LISTING on: nothing while the proxy has not answered, nothing when
// ABOUTME: it is off, the feed otherwise. The one component the Jobs page mounts for the open positions.
import { useJobFeedEnabled } from '../hooks';
import { JobFeed } from './JobFeed';

export const JobFeedGate = () => {
  const { isEnabled, isLoading } = useJobFeedEnabled();

  if (isLoading || !isEnabled) return null;

  return <JobFeed />;
};
